<template>
  <div class="userService">
    <div class="header">自审制度</div>
    <div class="serviceWrap" v-for="(item, index) in serviceList " :key="index">
      <div class="serviceWrap_title">{{ item.title }}</div>
      <div class="serviceWrap_con" v-if='item.id == 0'>
        我公司网站平台动漫，除了在技术、包装等领域严格规范，同时在放置的动漫的内容上将严格按 照《互联网文化管理暂行规定》、《国务院对确需保留的行政审批项目设定行政许可的决定》 、《文化部关于实施互联网文化管理暂行规定有关问题的通知》的相关要求来实施，严格平台动漫内容的 内部审查工作。
      </div>
      <div class="serviceWrap_con" v-if='item.id == 1'>
        <p>1.依照《网络文化经营单位内容自审管理办法》的有关要求制定本制度；</p>
        <p>2.设立专门岗位及专人承担产品内容自审工作，且承担该工作的工作人员须取得自审人员岗位资格；</p>
        <p>3.我公司自审由1名主要负责人和2名审核专员实施，审核人员填写审核意见并签字后，报内容审 查管理工作的主要负责人复核签字。</p>
      </div>
      <div class="serviceWrap_con" v-if='item.id == 2'>
        本规定用于规范网络文化产品及服务内容(包括但不限于产品的宣传推广，活动策划)的企业自审工 作，我公司按照《网络文化经营单位内容自审管理办法》开展相关工作的职责、流程、标准以及责任 追究办法。
        </div>
      <div class="serviceWrap_con" v-if='item.id == 3'>
        <p>本部门共有3人组成，简称自审委员会，岗位设置如下：</p>
        <p>内容自审主要负责人1名，由公司总经理担任：</p>
        <p>内容自审专员2名，由运营经理和技术员组成：</p>
        </div>
      <div class="serviceWrap_con" v-if='item.id == 4'>
        <p>1.掌握内容审核的政策法规和相关知识；</p>  
        <p>2.能独立表达审核意见；</p>
        <p>3.以最终保证本公司的产品和服务的合法性和合规性为目的，对在自身工作中发现的违法违规的 产品及服务内容进行记录并提请终止，作出提交修改，督促修改，复审等审核意见；</p>
        <p>4.负责保管审查记录；</p>
        <p>5.组织内部培训工作，对本公司开发、运营人员进行内容审查方面的培训。</p>
      </div>
      <div class="serviceWrap_con" v-if='item.id == 5'>
        <p>1.对本公司自主创作的作品，在研发阶段进行培训，对故事背景、美术素材等进行初步的筛查；</p>  
        <p>2.自审人员在作品发布之前，依据内容审查的相关规定，对产品及其服务内容(包括宣传推广和活 动策划)进行审查，对违法违规的内容进行记录，并签发初审意见；</p>
        <p>3.对初审有问题的作品，退回用户或部门进行修改，并对修改后的内容进行复查；</p>
        <p>4.对内容的合法合规性不能准确判断的，应向文化厅申请行政指导；</p>
        <p>5.对复查仍有问题的，应按照上述第2-4项规定的内容重新进行审核；</p>
        <p>6.在内容发布前，对作品内容进行审查，审查内容包括证照使用、实名注册、实名信息补填、用 户协议必备条款、适龄提示等内容，合格后方可发布作品;</p>
        <p>7.对审查完成的做品，自审人员提出同意发布的意见，用户签字确认，上交内容审查管理工作的 主要负责人；</p>
        <p>8.内容审查管理工作的主要负责人签字确认后，作品会由网站管理员发布到网站中。</p>
        <p>9.日常对作品和服务内容进行监督检查，包括作品内容、宣传推广和活动策划等各个方面和环节，发现问题提交检查意见，报本公司内容审查管理 工作主要负责人；</p>
        <p>10.自审人员的所有审查意见应归档留存，保存时间不少于两年。</p>
      </div>
      <div class="serviceWrap_con" v-if='item.id == 6'>
        <p>我公司网站平台不得含有以下内容：</p>  
       <p>1.反对宪法确定的基本原则的；</p>
       <p>2.危害国家统一、主权和领土完整的</p>
       <p>3.泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；</p>
       <p>4.煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；</p>
       <p>5.宣扬邪教、迷信的；</p>
       <p>6.散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
       <p>7.宣扬淫秽、赌博、暴力或者教唆犯罪的；</p>
       <p>8.侮辱或者诽谤他人，侵害他人合法权益的；</p>
       <p>9.危害社会公德或者民族优秀文化传统的；</p>
       <p>10.有法律、行政法规和国家规定禁止的其他内容的。</p>
      </div>
      <div class="serviceWrap_con" v-if='item.id == 7'>
        <p>我公司内部对审核人员、开发人员以及运营人员的内容审核责任制定明确的追究规定。</p>
        <p>对审查人员未能在审查过程中发现问题的，予以口头警告；对审查人员发现问题，但网站运营人员拒不修改的，予以书面警告；对审查人员发现问题，网站运营人员及时修改，审查通过后自行予以恢复的，予以扣除当月奖金。
</p>
<p>对运营人员在运营过程中未通知审查人员，造成不良后果，而审查人员也未及时发现的，予以扣 除当月奖金，累计满三次运营人员予以调离岗位，审查人员予以取消审查资格并调离岗位；</p>
<p>其他造成不良后果的情形的，予以书面警告。</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
let serviceList = ref([
  { title: '', id: 0 },
  { title: '（一）基本原则', id: 1 }, { title: '（二）自审目的', id: 2 }, { title: '（三）内容自审部门组织架构', id: 3 }, { title: '（四）审查人员职责', id: 4 }, { title: '（五）审查流程', id: 5 }, { title: '（六）审查标准', id: 6 }, { title: '（七）责任追究', id: 7 }
])

</script>

<style lang="scss" scoped>
.userService {
  .header {
    font-size: 28px;
    
    color: #333333;
    line-height: 40px;
  }

  .con {
    font-size: 18px;
    font-weight: 400;font-weight: lighter;
    color: #333333;
    line-height: 36px;
    margin-top: 30px;
  }

  .serviceWrap {
    &_title {
      // background-color: rgb(255, 127, 170);
      font-size: 22px;
      
      color: #333333;
      line-height: 30px;
      margin: 30px 0 20px;
    }

    &_con {
      font-size: 18px;
      font-weight: 400;font-weight: lighter;
      color: #333333;
      line-height: 36px;
    }

    &_con1 {
      font-size: 16px;
    }
  }

}
</style>